import { Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-[#222634] py-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="font-display font-extrabold text-lg">
          VR<span className="text-[#FF4D23]">.</span>{" "}
          <span className="text-xs font-mono2 font-normal tracking-widest text-[#8A92A3] uppercase ml-2">
            · Vijay Rajput · Design Leader
          </span>
        </p>
        <div className="flex items-center gap-6">
          <a
            href="mailto:kumar.edu12vk@gmail.com"
            data-testid="footer-email-link"
            aria-label="Email Vijay Rajput"
            className="text-[#B6BDCB] hover:text-[#FF4D23] transition-colors"
          >
            <Mail size={16} />
          </a>
          <p className="text-xs text-[#8A92A3]">© {new Date().getFullYear()} · Designed &amp; built by Vijay Rajput</p>
        </div>
      </div>
    </footer>
  );
}
